export default __webpack_public_path__ + "src/assets/twitter.06d3fca579e1d6dbb54a9adb336aff57.svg";